import {
  transform,
  groupBy,
  uniq,
  map,
  head,
  capitalize,
  sortBy,
  lowerCase,
  startCase
} from 'lodash'
import Role from '@/api/role'
import Permission from '@/api/permission'
import { baseState, baseMutations } from '@/store/mixins'

const getPermissionOrder = suffix => {
  switch (lowerCase(suffix)) {
    case 'view':
      return 0

    case 'create':
      return 1

    case 'update':
      return 2

    case 'delete':
      return 3

    default:
      return 4
  }
}

export const state = {
  ...baseState,
  permissions: [],
  searchPermissionText: ''
}

export const getters = {
  permissionGroups: state => {
    const permissions = state.permissions.filter(p => {
      return (
        p.resource
          .toLowerCase()
          .includes(state.searchPermissionText.toLowerCase()) ||
        (p.group !== null &&
          p.group
            .toLowerCase()
            .includes(state.searchPermissionText.toLowerCase()))
      )
    })

    return transform(
      groupBy(sortBy(permissions, p => p.order_group), permission => startCase(permission.group)),
      (result, value, key) => {
        result[key] = groupBy(
          sortBy(value, p => p.order),
          permission => startCase(permission.resource)
        )
      },
      {}
    )
  },
  permissionColumns: state => {
    return sortBy(
      uniq(
        map(state.permissions, p => {
          return capitalize(head(p.name.split('-')))
        })
      ),
      p => getPermissionOrder(p)
    )
  }
}

export const mutations = {
  ...baseMutations,
  RECEIVE_PERMISSIONS(state, permissions) {
    state.permissions = permissions.map(permission => {
      return {
        id: permission.id,
        name: permission.name,
        resource: permission.label,
        group: permission.group,
        order_group: permission.order_group,
        order: permission.order
      }
    })
  },
  SET_SEARCH_PERMISSION(state, searchPermissionText) {
    state.searchPermissionText = searchPermissionText
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return Role.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return Role.store(data)
  },

  update(context, { id, ...data }) {
    return Role.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await Role.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return Role.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.id == id)

      if (resource) {
        context.state.resources.splice(
          context.state.resources.indexOf(resource),
          1
        )
      }

      return response
    })
  },

  fetchPermissions(context, attributes) {
    return Permission.get({
      params: Object.assign({ page: -1 }, attributes)
    }).then(response => {
      context.commit('RECEIVE_PERMISSIONS', response.data)
      return Promise.resolve(response)
    })
  }
}
